import React, { useContext, useEffect, useState, useRef } from "react";
import { AppContext } from "./../context/AppContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";

import ic_delete from "../assets/images/ic_delete.svg";
import ic_edit from "../assets/images/ic_edit.svg";
import ic_eyes from "../assets/images/ic_eyes.svg";
import Modal from "react-bootstrap/Modal";
import ApiConfig from "../api/ApiConfig";
import {
  deleteWithAuthCall,
  getWithAuthCallWithErrorResponse,
  putWithAuthCall,
  putMultipartWithAuthCallWithErrorResponse,
  multipartPostCall,
  putMultipartWithAuthCall,
  simplePostCall,
} from "../api/ApiServices";
import swal from "sweetalert";
import { Table } from "react-bootstrap";
import Loading from "../sharedComponents/Loaders/Loading";
import BtnLoader from "../sharedComponents/Loaders/BtnLoader";
import { Pagination } from "./Pagination";
import DragAndDropSingleFile from "../sharedComponents/DragAndDropSingleFile";

const Categories = () => {
  const { sidebar, setCount, count } = useContext(AppContext);
  const [currentPage, setCurrentPage] = useState(0);
  const startIndex = currentPage * 15;
  const endIndex = startIndex + 15;
  const changePage = ({ selected }) => {
    setCurrentPage(selected);
  };

  // Refs for file inputs
  const addImageInputRef = useRef(null);
  const editImageInputRef = useRef(null);

  // Search func()ty state
  const [searchInput, setSearchInput] = useState("");

  const handleSearchInputChange = (e) => {
    setSearchInput(e.target.value);
  };

  const [showModalUpdate, setShowModalUpdate] = useState(false);
  const [showModalAdd, setShowModalAdd] = useState(false);
  const handleCloseModalAdd = () => setShowModalAdd(false);
  const handleCloseModalUpdate = () => setShowModalUpdate(false);
  const handleShowModalAdd = () => {
    setFileInputKey((prev) => prev + 1);
    setAddCategoryData({
      name: "",
      is_active: false,
      image_url: "",
      description: "",
      order: 0,
    });
    setShowModalAdd(true);
  };

  const [deleteShow, setDeleteShow] = useState(false);
  const handleDeleteClose = () => {
    setCategoryId(null);
    setDeleteShow(false);
  };
  const handleDeleteShow = (categoryId) => {
    setCategoryId(categoryId);
    setDeleteShow(true);
  };

  const [viewShow, setViewShow] = useState(false);
  const handleViewClose = () => setViewShow(false);
  const handleViewShow = () => setViewShow(true);

  const [validated, setValidated] = useState(false);

  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingDelete, setIsLoadingDelete] = useState(false);
  const [categoryId, setCategoryId] = useState(null);

  const [addCategoryData, setAddCategoryData] = useState({
    title: "",
    name: "",
    is_active: false,
    image_url: "",
    image_file: null,
    description: "",
    order: 0,
  });

  const [fileInputKey, setFileInputKey] = useState(0);
  const [editFileInputKey, setEditFileInputKey] = useState(0);

  const [editCategoryData, setEditCategoryData] = useState({
    id: null,
    title: "",
    name: "",
    is_active: false,
    image_url: "",
    image_file: null,
    description: "",
    order: 0,
  });

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      addCategory(event);
    }
    setValidated(true);
  };

  const handleSubmitFormUpdate = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      updateCategory(event);
    }
    setValidated(true);
  };

  // Add CAtegory
  const addCategory = (e) => {
    e.preventDefault();
    setIsLoading(true);
    let reqBody = JSON.stringify({
      title: addCategoryData.title,
      name: addCategoryData.name,
      is_active: addCategoryData.is_active,
      image_url: addCategoryData.image_url,
      image_file: addCategoryData.image_file,
      description: addCategoryData.description,
      order: addCategoryData.order ? +addCategoryData.order : 0,
    });
    let formData = new FormData();
    formData.append("title", addCategoryData.title);
    formData.append("name", addCategoryData.name);
    formData.append("is_active", addCategoryData.is_active);
    formData.append("image_url", addCategoryData.image_url);
    formData.append("image_file", addCategoryData.image_file);
    formData.append("description", addCategoryData.description);
    formData.append(
      "order",
      addCategoryData.order ? String(addCategoryData.order) : "0",
    );

    multipartPostCall(ApiConfig.ADD_CATEGORY, formData)
      .then((res) => {
        setIsLoading(false);
        handleCloseModalAdd();
        // console.log("res", res);
        if (res.success) {
          setAddCategoryData({
            name: "",
            is_active: false,
            image_url: "",
            image_file: null,
            description: "",
            order: 0,
          });
          swal({
            text: res.message,
            icon: "success",
            timer: 2000,
            dangerMode: false,
          });
          getCategories();
        } else {
          swal({
            text: res.message,
            icon: "error",
            timer: 2000,
            dangerMode: false,
          });
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const deleteCategory = () => {
    if (categoryId) {
      setIsLoadingDelete(true);
      const url = ApiConfig.DELETE_CATEGORY + "?id=" + categoryId;
      deleteWithAuthCall(url)
        .then((res) => {
          setIsLoadingDelete(false);
          setCategoryId(null);
          handleDeleteClose();
          if (res.status === 200) {
            swal({
              text: res.message,
              icon: "success",
              timer: 2000,
              dangerMode: false,
            });
            getCategories();
          } else {
            swal({
              text: res.message,
              icon: "error",
              timer: 2000,
              dangerMode: false,
            });
          }
        })
        .catch((err) => {
          setIsLoadingDelete(false);
          console.log(err);
        });
    }
  };

  const updateCategory = (event) => {
    event.preventDefault();
    setIsLoading(true);
    let formData = new FormData();
    formData.append("id", editCategoryData.id);
    formData.append("title", editCategoryData.title);
    formData.append("name", editCategoryData.name);
    formData.append("is_active", editCategoryData.is_active);
    formData.append("image_url", editCategoryData.image_url);
    formData.append("image_file", editCategoryData.image_file);
    formData.append("description", editCategoryData.description);
    formData.append(
      "order",
      editCategoryData.order ? String(editCategoryData.order) : "0",
    );
    console.log("reqBody", formData);
    putMultipartWithAuthCall(ApiConfig.UPDATE_CATEGORY, formData)
      .then((res) => {
        setIsLoading(false);
        handleCloseModalUpdate();
        if (res.success) {
          swal({
            text: res.message,
            icon: "success",
            timer: 2000,
            dangerMode: false,
          });
          getCategories();
        } else {
          swal({
            text: res.message,
            icon: "error",
            timer: 2000,
            dangerMode: false,
          });
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const getCategories = () => {
    setIsLoading(true);
    getWithAuthCallWithErrorResponse(ApiConfig.CATEGORIES)
      .then((res) => {
        let data = res.json;
        setCategories(data?.list);
        // This is commented becouse the data was getting stored in other props ?
        // setCount({ ...count, categoriesCount: data?.list?.length })
        if (data) {
          setCategories(data.list);
          setIsLoading(false);
        }
      })

      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getCategories();
    return () => {};
  }, []);

  const handleEditShow = (category) => {
    // Clear the file input when opening the edit modal
    if (editImageInputRef.current) {
      editImageInputRef.current.value = "";
    }
    setEditCategoryData(category);
    setShowModalUpdate(true);
  };

  const handleShowModalUpdate = (category) => {
    setEditFileInputKey((prev) => prev + 1);
    setEditCategoryData(category);
    setShowModalUpdate(true);
  };

  return (
    <main
      id="cx-main"
      className={sidebar ? "admin-main" : "cx-active admin-main"}
    >
      <div className="heading-btn-main">
        <div className="heading-common">
          <label htmlFor="">CATEGORIES</label>
        </div>
        <div className="add-btn">
          <button onClick={handleShowModalAdd}>
            Add Category
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              preserveAspectRatio="xMidYMid meet"
              viewBox="0 0 24 24"
            >
              <path fill="white" d="M11 19v-6H5v-2h6V5h2v6h6v2h-6v6Z" />
            </svg>
          </button>
        </div>
      </div>

      <Modal
        show={showModalAdd}
        onHide={handleCloseModalAdd}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>ADD CATEGORY</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div className="row align-items-center">
              <div className="col-md-12 mb-3">
                <Form.Label>Title</Form.Label>
                <Form.Control
                  type="text"
                  value={addCategoryData?.title}
                  onChange={(e) => {
                    setAddCategoryData({
                      ...addCategoryData,
                      title: e.target.value,
                    });
                  }}
                />
              </div>
            </div>
            <div className="row align-items-center">
              <div className="col-md-6 mb-3">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  required
                  type="text"
                  defaultValue={addCategoryData?.name}
                  onChange={(e) => {
                    setAddCategoryData({
                      ...addCategoryData,
                      name: e.target.value,
                    });
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Your Name.
                </Form.Control.Feedback>
              </div>

              <div className="col-md-6 ">
                <Form.Check
                  type="checkbox"
                  id="active"
                  label="Is Active?"
                  className="check-input"
                  onChange={(e) => {
                    setAddCategoryData({
                      ...addCategoryData,
                      is_active: e.target.checked,
                    });
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Your Last Name.
                </Form.Control.Feedback>
              </div>
            </div>

            <div className="row align-items-center">
              <div className="col-md-6 mb-3">
                <label for="position"> Position </label>
                <input
                  className="form-control"
                  value={addCategoryData.order}
                  type="text"
                  id="position"
                  name="position"
                  onChange={(e) => {
                    setAddCategoryData({
                      ...addCategoryData,
                      order: e.target.value,
                    });
                  }}
                />
              </div>
            </div>

            <div className="row align-items-center">
              <div className="col-md-12 mb-3">
                <Form.Label>Featured Product Image</Form.Label>
                <div>
                  <DragAndDropSingleFile
                    key={`add_${fileInputKey}`}
                    setFile={(file) => {
                      setAddCategoryData({
                        ...addCategoryData,
                        image_file: file,
                      });
                    }}
                    inputRef={addImageInputRef}
                    inputId="add_image_file"
                    inputName="image_file"
                    name="Select Featured Product Image"
                  />
                  <div className="uploaded_items d-flex mt-2 mb-2">
                    {addCategoryData.image_file && (
                      <div
                        className="item_list position-relative d-inline-block"
                        key={"image_file"}
                      >
                        <img
                          width={72}
                          height="72"
                          className="product_img"
                          src={
                            addCategoryData.image_file.name
                              ? URL.createObjectURL(addCategoryData.image_file)
                              : addCategoryData.image_file
                          }
                          alt=""
                        />
                        <button
                          type="button"
                          className="btn btn-danger btn-sm position-absolute"
                          style={{
                            top: "-10px",
                            right: "-10px",
                            borderRadius: "50%",
                            width: "24px",
                            height: "24px",
                            padding: "0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          onClick={() => {
                            setAddCategoryData({
                              ...addCategoryData,
                              image_file: null,
                            });
                            setFileInputKey((prev) => prev + 1);
                          }}
                        >
                          ×
                        </button>
                      </div>
                    )}
                  </div>
                </div>
                <Form.Control
                  type="text"
                  value={addCategoryData?.image_url}
                  onChange={(e) => {
                    setAddCategoryData({
                      ...addCategoryData,
                      image_url: e.target.value,
                    });
                  }}
                />
                {addCategoryData.image_url && (
                  <img
                    src={addCategoryData.image_url}
                    alt="Category"
                    style={{ marginTop: "10px", maxWidth: "100%" }}
                  />
                )}
              </div>
            </div>

            <div className="row align-items-center">
              <div className="col-md-12 mb-3">
                <Form.Label>Featured Product Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={addCategoryData?.description}
                  onChange={(e) => {
                    setAddCategoryData({
                      ...addCategoryData,
                      description: e.target.value,
                    });
                  }}
                />
              </div>
            </div>

            <Modal.Footer>
              <div className="buttons-modal">
                <button
                  className="me-2"
                  type="button"
                  onClick={handleCloseModalAdd}
                >
                  Cancel
                </button>
                <button className="" type="submit">
                  {isLoading ? <BtnLoader /> : "Add"}
                </button>
              </div>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal
        show={viewShow}
        onHide={handleViewClose}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>CATEGORY DETAILS</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="row user-detail">
            <div className="col-3 ">
              <label htmlFor="">Name:</label>
            </div>
            <div className="col-3 ">
              <span>Mangesh </span>
            </div>
          </div>

          <div className="row user-detail">
            <div className="col-3 ">
              <label htmlFor="">Status :</label>
            </div>
            <div className="col-3 ">
              <span>Inactive </span>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={deleteShow}
        onHide={handleDeleteClose}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="delete-msg text-center">
            <label htmlFor="">Are you sure you want to delete?</label>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <div className="buttons-modal">
            <button
              className="me-2"
              type="submit"
              style={{ backgroundColor: "red" }}
              onClick={deleteCategory}
            >
              {isLoadingDelete ? <BtnLoader /> : "Delete"}
            </button>
            <Link to="#" className="" onClick={handleDeleteClose}>
              Cancel
            </Link>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showModalUpdate}
        onHide={handleCloseModalUpdate}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>EDIT CATEGORY</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            noValidate
            validated={validated}
            onSubmit={handleSubmitFormUpdate}
          >
            <div className="row align-items-center">
              <div className="col-md-12 mb-3">
                <Form.Label>Title</Form.Label>
                <Form.Control
                  type="text"
                  value={editCategoryData?.title}
                  onChange={(e) => {
                    setEditCategoryData({
                      ...editCategoryData,
                      title: e.target.value,
                    });
                  }}
                />
              </div>
            </div>
            <div className="row align-items-center">
              <div className="col-md-6 mb-3">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  required
                  type="text"
                  value={editCategoryData?.name}
                  onChange={(e) => {
                    setEditCategoryData({
                      ...editCategoryData,
                      name: e.target.value,
                    });
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Your Name.
                </Form.Control.Feedback>
              </div>
              <div className="col-md-6 ">
                <Form.Check
                  type="checkbox"
                  id="active"
                  label="Is Active?"
                  className="check-input"
                  checked={editCategoryData?.is_active} // Gán giá trị từ editCategoryData
                  onChange={(e) => {
                    setEditCategoryData({
                      ...editCategoryData,
                      is_active: e.target.checked,
                    });
                  }}
                />
              </div>
            </div>

            <div className="row align-items-center">
              <div className="col-md-6 mb-3">
                <label for="position"> Position </label>
                <input
                  className="form-control"
                  value={editCategoryData.order}
                  type="text"
                  id="position"
                  name="position"
                  onChange={(e) => {
                    setEditCategoryData({
                      ...editCategoryData,
                      order: e.target.value,
                    });
                  }}
                />
              </div>
            </div>

            <div className="row align-items-center">
              <div className="col-md-12 mb-3">
                <Form.Label>Featured Product Image</Form.Label>
                <div>
                  <DragAndDropSingleFile
                    key={`edit_${editFileInputKey}`}
                    setFile={(file) => {
                      setEditCategoryData({
                        ...editCategoryData,
                        image_file: file,
                      });
                    }}
                    inputRef={editImageInputRef}
                    inputId="edit_image_file"
                    inputName="image_file"
                    name="Select Featured Product Image"
                  />
                  <div className="uploaded_items d-flex mt-2 mb-2">
                    {editCategoryData.image_file && (
                      <div
                        className="item_list position-relative d-inline-block"
                        key={"image_file"}
                      >
                        <img
                          width={72}
                          height="72"
                          className="product_img"
                          src={
                            editCategoryData.image_file.name
                              ? URL.createObjectURL(editCategoryData.image_file)
                              : editCategoryData.image_file
                          }
                          alt=""
                        />
                        <button
                          type="button"
                          className="btn btn-danger btn-sm position-absolute"
                          style={{
                            top: "-10px",
                            right: "-10px",
                            borderRadius: "50%",
                            width: "24px",
                            height: "24px",
                            padding: "0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          onClick={() => {
                            setEditCategoryData({
                              ...editCategoryData,
                              image_file: null,
                            });
                            setEditFileInputKey((prev) => prev + 1);
                          }}
                        >
                          ×
                        </button>
                      </div>
                    )}
                  </div>
                </div>
                <Form.Control
                  type="text"
                  value={editCategoryData?.image_url}
                  onChange={(e) => {
                    setEditCategoryData({
                      ...editCategoryData,
                      image_url: e.target.value,
                    });
                  }}
                />
                {editCategoryData.image_url && (
                  <img
                    src={editCategoryData.image_url}
                    alt="Category"
                    style={{ marginTop: "10px", maxWidth: "100%" }}
                  />
                )}
              </div>
            </div>

            <div className="row align-items-center">
              <div className="col-md-12 mb-3">
                <Form.Label>Featured Product Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={editCategoryData?.description}
                  onChange={(e) => {
                    setEditCategoryData({
                      ...editCategoryData,
                      description: e.target.value,
                    });
                  }}
                />
              </div>
            </div>

            <Modal.Footer>
              <div className="buttons-modal">
                <button
                  className="me-2"
                  type="button"
                  onClick={handleCloseModalUpdate}
                >
                  Cancel
                </button>
                <button className="" type="submit">
                  {isLoading ? <BtnLoader /> : "Save Changes"}
                </button>
              </div>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>

      <div className="table-wrapper">
        <div className="headerFlex">
          <div className="innerLabel">
            <label className="labelTxt">
              Total Records : {categories.length}
            </label>
          </div>
          <div className="searchFilter">
            <input
              type="text"
              className="form-control"
              placeholder="Search By Name ..."
              value={searchInput}
              onChange={handleSearchInputChange}
            />
          </div>
        </div>
        {isLoading ? (
          <Loading />
        ) : (
          <Table striped hover id="Categories" class="table display">
            <thead>
              <tr>
                <th>Sr No.</th>
                <th>Name</th>
                <th>Status</th>
                <th>Product Count</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {categories?.length > 0 &&
                categories
                  .filter((item) => {
                    return item.name
                      .toLowerCase()
                      .includes(searchInput.toLowerCase());
                  })
                  .slice(startIndex, endIndex)
                  .map((category, index) => {
                    if (!category.is_deleted) {
                      return (
                        <tr key={"category" + index}>
                          <td>{index + 1}</td>
                          <td>{category?.name ? category?.name : "NA"}</td>
                          <td>{category?.is_active ? "ACTIVE" : "INACTIVE"}</td>
                          <td>
                            {category?.number_of_products
                              ? category?.number_of_products
                              : 0}
                          </td>

                          <td className="action">
                            <Link
                              to="#"
                              className="icon"
                              onClick={() => handleEditShow(category)}
                            >
                              <img src={ic_edit} alt="Edit" />
                            </Link>
                            {/* <Link to="#" className="icon" onClick={handleViewShow}>
                                    <img src={ic_eyes} alt="" />
                                  </Link> */}
                            {!category.number_of_products ||
                            category.number_of_products === 0 ? (
                              <Link
                                to="#"
                                className="icon"
                                onClick={() => handleDeleteShow(category.id)}
                              >
                                <img src={ic_delete} alt="" />
                              </Link>
                            ) : (
                              ""
                            )}
                          </td>
                        </tr>
                      );
                    }
                    return null;
                  })}
            </tbody>
          </Table>
        )}
        <div className="d-flex justify-content-end">
          {categories && categories.length > 0 ? (
            <Pagination
              changePage={changePage}
              pageCount={categories?.length / 15}
              currentPage={currentPage}
            />
          ) : (
            <div>
              <h5 style={{ color: "red" }}> Records Not Found</h5>
            </div>
          )}
        </div>
      </div>
    </main>
  );
};

export default Categories;
